import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../constants/Config';
import {
  GET_APNS_LIST,
  GET_APNS_LIST_SUCCESS,
  GET_APNS_LIST_ERROR,
  ADD_APN,
  ADD_APN_SUCCESS,
  ADD_APN_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/apn';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.apn;
const apn = (state = initialSettings, action) => {
  switch (action.type) {
    // LIST
    case GET_APNS_LIST:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case GET_APNS_LIST_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case GET_APNS_LIST_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.data),
            pageNumber: _parseInt(action.data.page_number),
            pageSize: _parseInt(action.data.page_size),
            totalEntries: _parseInt(action.data.total_entries),
            totalPages: _parseInt(action.data.total_pages),
          },
        },
      };
    // ADD
    case ADD_APN:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_APN_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_APN_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    default:
      return state;
  }
};

export default apn;



// WEBPACK FOOTER //
// ./reducers/simcard/apn.js